import { put, call, takeEvery } from "redux-saga/effects";
import request from "utils/api";
import _pick from "lodash/pick";
import _isEmpty from "lodash/isEmpty";
import { safe } from "providers/GeneralProvider/saga";
import Helper from "utils/helpers";
import {
  getCandidateListRequest,
  getCandidateListSuccess,
  createCandidateRequest,
  createCandidateSuccess,
  stopLoading,
  deleteCandidateRequest,
  deleteCandidateSuccess,
  updateCandidateRequest,
  updateCandidateSuccess,
  getCandidateDetailRequest,
  getCandidateDetailSuccess,
} from "./slice";

function* getCandidateList(action) {
  try {
    const params = _pick(action.payload, [
      "page",
      "limit",
      "keyword",
      "sortField",
      "sortOrder",
      "contestId",
      "sortByRanking",
    ]);

    // Set default values if not provided
    if (!params.page) params.page = 1;
    if (!params.limit) params.limit = 10;

    // Handle keyword processing if needed
    if (!_isEmpty(params.keyword)) {
      params.keyword =
        Helper.sortStringWithoutSpecialChars(params.keyword) || undefined;
    }

    const { data } = yield call(
      request,
      "api/contest/admin/candidates",
      params,
      {
        method: "GET",
      }
    );

    yield put(getCandidateListSuccess(data));
  } catch (error) {
    yield put(stopLoading());
  }
}

function* createCandidate(action) {
  try {
    const candidateData = action.payload;
    const { meta } = action;

    const data = yield call(
      request,
      "api/contest/admin/candidates",
      candidateData,
      {
        method: "POST",
      }
    );

    yield put(createCandidateSuccess(data, meta));
  } catch (error) {
    yield put(stopLoading());
    throw error; // Re-throw the error so the component can catch it
  }
}

function* deleteCandidate(action) {
  try {
    const candidateId = action.payload;
    const { meta } = action;

    const data = yield call(
      request,
      `api/contest/admin/candidates/${candidateId}`,
      {},
      {
        method: "DELETE",
      }
    );

    yield put(deleteCandidateSuccess(data, meta));
  } catch (error) {
    yield put(stopLoading());
    throw error;
  }
}

function* updateCandidate(action) {
  try {
    const { candidateId, candidateData } = action.payload;
    const { meta } = action;

    const data = yield call(
      request,
      `api/contest/admin/candidates/${candidateId}`,
      candidateData,
      {
        method: "PUT",
      }
    );

    yield put(updateCandidateSuccess(data, meta));
  } catch (error) {
    yield put(stopLoading());
    throw error;
  }
}

function* getCandidateDetail(action) {
  try {
    const candidateId = action.payload;

    const { data } = yield call(
      request,
      `api/contest/admin/candidates/${candidateId}`,
      {},
      {
        method: "GET",
      }
    );

    yield put(getCandidateDetailSuccess(data));
  } catch (error) {
    yield put(stopLoading());
    throw error;
  }
}

function* onError() {
  yield put(stopLoading());
}

export default function* watchCandidateManager() {
  yield takeEvery(
    getCandidateListRequest.type,
    safe(getCandidateList, onError)
  );
  yield takeEvery(createCandidateRequest.type, safe(createCandidate, onError));
  yield takeEvery(deleteCandidateRequest.type, safe(deleteCandidate, onError));
  yield takeEvery(updateCandidateRequest.type, safe(updateCandidate, onError));
  yield takeEvery(
    getCandidateDetailRequest.type,
    safe(getCandidateDetail, onError)
  );
}
